import React, { memo } from 'react';
import { Popover } from '@material-ui/core';
import DecisionTree from '@shared/components/DecisionTree';
import { useManageUsersRolePopover } from '@shared/components/ManageUsersModalTable/hooks';
import {
  ManageUsersRolePopoverProps,
  User
} from '@shared/components/ManageUsersModalTable/types';
import classNames from './ManageUsersModalPopover.module.scss';

const ManageUsersRolePopover: React.FC<ManageUsersRolePopoverProps> = ({
  ifUserAdmin = false,
  ifUserOpikMember = false,
  ifChangeWsRoleDisabled = false,
  username = '',
  permissions = [],
  onClose,
  setPermissions,
  popoverPosition = {},
  currentUser = {} as User
}) => {
  const decisionTreeProps = useManageUsersRolePopover(
    permissions,
    currentUser,
    username,
    ifChangeWsRoleDisabled,
    ifUserAdmin,
    ifUserOpikMember,
    setPermissions
  );

  return (
    <Popover
      elevation={0}
      classes={{
        paper: classNames.manageUsersModalPopover
      }}
      id="manageUsersWorkspaceRolePopover"
      open={Boolean(popoverPosition?.y && popoverPosition?.x)}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: Number(popoverPosition?.y) || 0,
        left: Number(popoverPosition?.x) || 0
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      onClose={onClose}
    >
      <DecisionTree {...decisionTreeProps} />
    </Popover>
  );
};

export default memo(ManageUsersRolePopover);
